import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { isSuccess } from 'utils/responseStatus';

import { useDeleteDriverTransportMutation } from 'bus/driverTransport/driverTransport';

type Props = {
  driverId: number;
  transportId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DeleteModal: FC<Props> = ({ changeVisible, driverId, transportId, refresh, visible }) => {
  const [deleteDriverTransport, { isLoading }] = useDeleteDriverTransportMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    deleteDriverTransport({ driverId, transportId }).then((data: any) => {
      if (isSuccess(data)) {
        refresh();
        changeVisible(false);
      }
    });
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить?</div>
            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DeleteModal;
